import { Component } from '@angular/core';
import { ViewController, PopoverController, NavParams, Events, NavController, AlertController } from 'ionic-angular';
import { AppState } from '../../config/state';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';
import { HidScannerProvider } from '../../providers/hid-scanner/hid-scanner';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { CoSelfcheckAccountPage } from '../../pages/co-selfcheck-account/co-selfcheck-account';
import { LoginProvider } from '../../providers/login/login';
/**
 * Generated class for the CoBookScannerPopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-book-scanner-popover',
  templateUrl: 'co-book-scanner-popover.html'
})
export class CoBookScannerPopoverComponent {
  scanInfo: any = "";
  isForApp: boolean;
  showNumberpad: boolean = false;
  typeToEnter: boolean = false;
  autoCLose: boolean = true;
  doneFunc: Function;
  blockInfo: any;
  pageTitle: string = "Scan";
  appScanTab: string = "scan";
  scope: string = "scan";
  loading: boolean = false;
  private scanTab: string;
  private hidSubscription: any;
  private stopNavPop: boolean = false;
  private chooseScreen: boolean = true;
  // pageIsLoaded: boolean = false;

  constructor(public toast: ToastAlertsProvider, public viewCtrl: ViewController, public popoverCtrl: PopoverController, public navParams: NavParams, public state: AppState, private events: Events, private timeout: TimeoutFunctionsProvider, public navCtrl: NavController, private hidScanner: HidScannerProvider, private sounds : SoundsProvider, private loginProvider: LoginProvider, private alertCtrl: AlertController) {
    // window.hasOwnProperty('cordova') ? this.isForApp = true : this.isForApp = false;
    this.isForApp = this.state.cordovaAvailable;

    this.events.subscribe('timeoutCalled', () => this.timeout.doLogoutFunctions(this));

    if(this.navParams.data && this.navParams.data.hasOwnProperty('autoCLose')){
    this.autoCLose = this.navParams.get('autoCLose')
    }
    if(this.navParams.data && this.navParams.data.hasOwnProperty('onDone')){
      this.doneFunc = this.navParams.get('onDone')
    }
    if(this.navParams.data && this.navParams.data.hasOwnProperty('blockInfo')){
      this.blockInfo = this.navParams.get('blockInfo');
      this.pageTitle = "Do we have it?";
    }
    if(this.navParams.data && this.navParams.data.hasOwnProperty('stopNavPop')){
      this.stopNavPop = this.navParams.get('stopNavPop');
    }
    if(this.navParams.data && this.navParams.data.hasOwnProperty('scope')){
      let scope = this.navParams.get('scope');

      if (scope == 'checkout'){
        this.scope = 'checkout'
        this.pageTitle = 'Checkout';
      } else if (scope == 'checkin'){
        this.pageTitle = 'Check-in';
        this.scope = 'checkout';
      }
    }
  }

  ngAfterViewInit(): void {
	this.scanTab = 'scan';
    this.sounds.playSoundOnButtonClick();
  }

  ionViewWillEnter() {
    this.state.homeScanActive = false;
    if (!this.isForApp || this.state.physicalScanner) {
      this.hidSubscription = this.hidScanner.scan.subscribe(value => {
        this.scanInfo = value;
        this.close(true);
      });
      this.hidScanner.start();
    }
  }
  ionViewWillLeave() {
    this.state.homeScanActive = true;
  }
  scrollToInput(event){
    setTimeout(()=>event._elementRef.nativeElement.scrollIntoView(), 750);
  }
  myAccount(){
	this.viewCtrl.dismiss({},'', {animate: false}).then(()=>{
		this.state.nav.push(CoSelfcheckAccountPage);
	}).catch(err=>{});
  }
  scanForInfo(isbn: boolean) {
    let lintWindow: any = window;
    this.loading = true;
    if(lintWindow.cordova && lintWindow.cordova.plugins) {
      lintWindow.cordova.plugins.CoScanner.scan({
        message: isbn ? "Please scan an ISBN barcode" : "Please scan a library item barcode",
        isISBN: isbn
      }, (data) => {
        if (data.success == true) {
          this.scanInfo = data.result;
          this.close(true);
        }
      }, (error) => {
        this.loading = false;
      });
    }
  }
  numberKeyPressed(event) {
    if (event === '<') {
      this.scanInfo = this.scanInfo.slice(0, -1);
    } else if (event === '*') {
    } else {
      this.scanInfo += event;
    };
  }
  onDone(func){
    this.doneFunc = func;
  }
  logout() {
	let alert = this.alertCtrl.create({
		title: 'Logout',
		cssClass:'confirm-alert',
		message: 'Do you want to log out?',
		buttons: [
		  {
			text: 'No',
			role: 'cancel',
			cssClass: 'confirm-button-outline',
			handler: () => {
			  return;
			}
		  },
		  {
			text: 'Yes',
			cssClass: 'confirm-button',
			handler: () => {
				this.viewCtrl.dismiss({},'', {animate: false}).then(()=>{
					this.loginProvider.logout().then( done =>{
						if( done ){
							this.state.nav.popToRoot();
						}
					})
				}).catch(err=>{});
			}
		  }
		]
	  });
	  alert.present();
  }
  close(code) {
    if (code && (!this.scanInfo || this.scanInfo.length <= 0)) {
      this.toast.triggerToast('Please enter a library barcode', '');
      return;
    }
    if (!this.isForApp || this.state.physicalScanner) {
      this.hidScanner.stop();
      this.hidSubscription.unsubscribe();
      this.events.publish('closeKeyboard');
    }
    if (this.doneFunc && code) {
      this.doneFunc({ info: code ? this.scanInfo : '' });
    } else {
      this.viewCtrl.dismiss({ info: code ? this.scanInfo : '' }, '', { animate: false }).catch(err => { });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-book-scanner-popover/co-book-scanner-popover.ts